import React from "react";
import {
  GET_GROUP_BY,
  SET_SELECTED_GROUP,
  UNGROUPED,
  securityLegend,
  visibilityLegend,
  SET_SITEMAP_EXPAND_ACCORDION,
  secondDropdownValues,
  GET_SECOND_TAGS_DROPDOWN,
  USER_TAGS,
  SYSTEM_TAGS,
  defaultPaginationModel,
  GET_SUB_TAG_DATA,
  GET_GROUP_BY_DATA,
} from "./NetSpaceConstant";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { MenuItem, Select, useMediaQuery } from "@material-ui/core";
import { NetSpaceSecondDropdown, renderIsMonitored } from "./NetSpaceUtils";
import Chip from "@material-ui/core/Chip";
import { startCase, toLower } from "lodash";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import LazyAccordion from "./LazyAccordion";
const LazyNetSpaceTable = React.lazy(() => import("./NetSpaceTable"));

const ControlPanel = () => {
  const dispatch = useDispatch();
  const isSmall = useMediaQuery("(max-width:1600px)");
  const isMediumQuery = useMediaQuery("(max-width:2000px)");
  const groups = useSelector((state) => state.NetspaceReducer.groups);
  const selectedGroup = useSelector(
    (state) => state.NetspaceReducer.selectedGroup
  );
  const groupCount = useSelector((state) => state.NetspaceReducer.groupCount);
  const accordionData = useSelector(
    (state) => state.NetspaceReducer.accordionData
  );
  const expandAccordionState = useSelector(
    (state) => state.NetspaceReducer.expandAccordion
  );
  const paginationModel =
    accordionData && accordionData.paginationModel
      ? accordionData.paginationModel
      : defaultPaginationModel;
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [secondGroupCode, setSecondGroupCode] = useState(null);
  const [selectedSubGroup, setSelectedSubGroup] = useState(null);
  const [selectOpen, setSelectOpen] = useState(false);

  useEffect(() => {
    dispatch({
      type: GET_GROUP_BY,
    });
  }, []);

  useEffect(() => {
    if (
      secondDropdownValues.includes(selectedGroup) &&
      Object.keys(groupCount).length > 0
    ) {
      dispatch({
        type: GET_SUB_TAG_DATA,
        payload: {
          selectedTag: selectedGroup,
          secondTag: selectedSubGroup,
          data: Object.keys(groupCount).map((key) => ({ value: key })),
          page: paginationModel.page,
          size: paginationModel.pageSize,
        },
      });
    } else {
      dispatch({
        type: GET_GROUP_BY_DATA,
        payload: {
          key: selectedGroup,
          values: selectedGroup === UNGROUPED ? [""] : Object.keys(groupCount),
          pageNo: paginationModel.page,
          pageSize: paginationModel.pageSize,
        },
      });
    }
  }, [selectedGroup, selectedSubGroup, groupCount]);


  const handleAccordionExpand = (accordionName) => {
    let expandAccordionUpdate = { ...expandAccordionState };
    expandAccordionUpdate[accordionName] =
      !expandAccordionUpdate[accordionName];
    dispatch({
      type: SET_SITEMAP_EXPAND_ACCORDION,
      payload: expandAccordionUpdate,
    });
  };

  useEffect(() => {
    dispatch({
      type: GET_SECOND_TAGS_DROPDOWN,
      payload: { selectedTag: USER_TAGS },
    });
    dispatch({
      type: GET_SECOND_TAGS_DROPDOWN,
      payload: { selectedTag: SYSTEM_TAGS },
    });
    if (secondDropdownValues.includes(selectedGroup)) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [selectedGroup]);

  const menuProps = {
    disableAutoFocusItem: true,
    MenuListProps: {
      onMouseDown: (event) => {
        const target = event.target.closest('[data-second-tag-group="true"]');
        if (target) {
          event.preventDefault();
        }
      },
    },
  };

  const renderSideArrow = (group) => {
    const isSecondTagGroup = secondDropdownValues.includes(group.code);

    const handleClick = () => {
      dispatch({
        type: SET_SELECTED_GROUP,
        payload: {group: group.code, place: "non-widget" },
      });
    };

    const handleChevronClick = (e) => {
      e.stopPropagation(); // prevent parent click
      setSecondGroupCode(group.code);
      setAnchorEl(e.currentTarget); // anchor for dropdown
    };

    return (
      <MenuItem value={group.code} key={group.code} onClick={handleClick}>
        <div className="netspace-group-menu-item">
          <div className="netspace-group-menu-label">{group.value}</div>
          {isSecondTagGroup && (
            <ChevronRightIcon
              onClick={handleChevronClick}
              style={{ cursor: "pointer" }}
            />
          )}
        </div>
      </MenuItem>
    );
  };

  const topThree = Object.entries(groupCount || {})
    .sort((a, b) => b[1] - a[1])
    .slice(0, 3);

  const totalGroups = Object.keys(groupCount || {}).length;

  const renderDropdownValue = () => {
    if (selectedGroup === UNGROUPED) {
      return (
        <div
          className="header-count-item"
          onClick={() => handleAccordionExpand("")}
        >
          <div className="header-count-item-label">
            {startCase(toLower(UNGROUPED))}
          </div>
          <div className="header-count-item-value">
            <Chip label={accordionData[""]?.data?.totalElements || 0} />
          </div>
        </div>
      );
    } else {
      return topThree.map(([key, count]) => (
        <div
          key={key}
          title={key ? startCase(toLower(key)) : "NA"}
          className="header-count-item"
          onClick={() => handleAccordionExpand(key)}
        >
          <div className="header-count-item-label">
            {key ? startCase(toLower(key)) : "NA"}
          </div>
          <div className="header-count-item-value">
            <Chip label={count} />
          </div>
        </div>
      ));
    }
  };

  return (
    <>
      <div className="control-panel">
        {groups && groups.length > 0 && (
          <div className="netspace-selection">
            <span className="selection-lbl">Group By: </span>
            <Select
              labelId="table-select-label"
              label="Group By"
              id="group-by-select"
              fontSize={isSmall || isMediumQuery ? "1rem" : "2rem"}
              value={selectedGroup}
              open={selectOpen}
              onOpen={() => setSelectOpen(true)}
              onClose={() => setSelectOpen(false)}
              renderValue={(value) => {
                const mainGroup = startCase(toLower(value));
                const subGroup = selectedSubGroup
                  ? ` ➝ ${selectedSubGroup}`
                  : "";
                return !secondDropdownValues.includes(selectedGroup)
                  ? `${mainGroup}`
                  : `${mainGroup}${subGroup}`;
              }}
            >
              {groups &&
                groups.map((group) => {
                  return renderSideArrow(group);
                })}
            </Select>
          </div>
        )}
        <div className="header-total-host">
          {selectedGroup === UNGROUPED
            ? "Total Hosts"
            : totalGroups > 3
            ? "Top 3 Hosts:"
            : "Total Hosts:"}
        </div>
        <div className="header-counts">{renderDropdownValue()}</div>
        <div className="header-legend">
          Security Alerts:
          {securityLegend.map((s) => {
            const className = "item " + s.class;
            return <span className={className}>{s.label}</span>;
          })}
        </div>
        <div className="header-legend visibility">
          Visibility:
          {visibilityLegend.map((s) => {
            const className = "item " + s.class + " visibility";
            return (
              <span className={className}>
                {renderIsMonitored({ row: { isMonitored: s.isMonitored } })}
                {s.label}
              </span>
            );
          })}
        </div>
      </div>
      <div className="netspace-tbl-container">
        {selectedGroup === UNGROUPED ? (
          <LazyAccordion
            label={startCase(toLower(UNGROUPED))}
            count={accordionData[""]?.data?.totalElements || 0}
            groupKey=""
            isExpanded={expandAccordionState[""] || false}
            onToggle={handleAccordionExpand}
            LazyComponent={LazyNetSpaceTable}
          />
        ) : (
          Object.keys(groupCount).map((key) => (
            <LazyAccordion
              key={key}
              label={startCase(toLower(key))}
              count={groupCount[key]}
              groupKey={key}
              isExpanded={expandAccordionState[key] || false}
              onToggle={handleAccordionExpand}
              LazyComponent={LazyNetSpaceTable}
            />
          ))
        )}
      </div>

      <div className="netspace-second-dropdown-container">
        <NetSpaceSecondDropdown
          anchorEl={anchorEl}
          loc={secondGroupCode}
          onClose={() => {
            setSelectOpen(false);
            setAnchorEl(null);
          }}
          onSelect={(subGroupCode) => setSelectedSubGroup(subGroupCode)} // new
        />
      </div>
    </>
  );
};

export default ControlPanel;
